export default function showCurrentRisk() {
    const risks = [
      {
        title: 'Geringes Risiko',
        text: 'KI-Systeme in dieser Kategorie, wie Chatbots und Spam-Filter, stellen kaum bis gar keine Bedrohung für individuelle Rechte dar.<br/> Sie unterliegen minimalen Vorschriften und müssen hauptsächlich bestimmte Transparenzkriterien erfüllen,<br/> wenn sie direkt mit Menschen interagieren.',
        audio: null
      },
      {
        title: 'Begrenztes Risiko',
        text: 'Systeme mit begrenztem Risiko sind im Allgemeinen nicht reguliert, haben aber einige Transparenzanforderungen.<br/> Hierzu zählen Allzweck-KI-Systeme (GPAI), sofern sie kein systemisches Risiko darstellen,<br/> wie etwa negative Auswirkungen auf die öffentliche Gesundheit, die Grundrechte oder die Gesellschaft.',
        audio: '/audios/BegrenztesRisiko_KI-Telefonassistent.mp3'
      },
      {
        title: 'Hohes Risiko',
        text: 'KI-Systeme, die als „hohes Risiko“ eingestuft werden, unterliegen den strengsten Anforderungen und Standards gemäß dem EU-KI-Gesetz.<br/> Diese Systeme werden in kritischen Bereichen eingesetzt, wie zum Beispiel:<br/> -Wesentliche wirtschaftliche und öffentliche Dienstleistungen<br/>-Beschäftigung (z.B. Personalbeschaffung)<br/>-Sicherheitskomponenten<br/>-Biometrie<br/>-Kritische Infrastrukturen<br/>Beispiele hierfür sind Systeme, die bei der Personalbeschaffung, Bonitätsprüfungen und Zulassungsverfahren zum Einsatz kommen.<br/> Da ein unsachgemäßer Einsatz dieser Systeme erhebliche Folgen haben könnte, konzentriert sich das EU-KI-Gesetz stark auf deren Regulierung.',
        audio: null
      },
      {
        title: 'Untragbares Risiko',
        text: 'Bestimmte KI-Systeme werden als „unannehmbares Risiko“ für die Sicherheit und die Rechte<br/> des Einzelnen eingestuft und sind daher durch das EU-KI-Gesetz ausdrücklich verboten.<br/> Dazu gehören Systeme, die:<br/> -Schwachstellen ausnutzen<br/> -Personen manipulieren oder irreführen <br/>-Emotionen ableiten <br/>-Gesichtserkennungsdatenbanken auswerten <br/>-Biometrische Daten zur Kategorisierung von Personen verwenden (z.B. Sozialkredit-Systeme)',
        audio: null
      }
    ]
  
    let currentIndex = 0
    const overlay = document.getElementById('risk-overlay')
    const textDiv = document.getElementById('risk-text')
    const audioEl = document.getElementById('risk-audio')
    const nextBtn = document.getElementById('risk-next')
  
    function updateView() {
      const current = risks[currentIndex]
      textDiv.innerHTML = `<h3>${current.title}</h3><p>${current.text}</p>`
  
      if (current.audio) {
        audioEl.src = current.audio
        audioEl.style.display = 'block'
        audioEl.play().catch(e => console.warn('Audio konnte nicht abgespielt werden.', e))
      } else {
        audioEl.pause()
        audioEl.style.display = 'none'
      }
    }
  
    nextBtn.onclick = () => {
      currentIndex = (currentIndex + 1) % risks.length
      updateView()
    }
    overlay.classList.add('show')
    updateView()
  }
  